import { tw } from '@/utils/tw';

const ArticleDisclosureLabel = tw.theme({
  base: `sticky z-article-disclosure w-full bg-primary-900 px-2 py-1 text-center text-white transition-transform duration-500 ease-in-out wings wings-primary-900 text-body-xs`,
});

export default ArticleDisclosureLabel;
